module.exports = __webpack_public_path__ + "img/heatmap-layer.57b4cbd6.svg";